import { IAppFile } from '@quicktools/shared-components/hooks/converterBase/types';

export function getPathFromUrl(url: string) {
  return url.split(/[?#]/)[0];
}

export async function convertImageFilesToBlobs(
  files: File[] | string[],
): Promise<IAppFile[] | null> {
  try {
    let blobFiles;

    if (typeof files[0] == 'string') {
      blobFiles = files.map((file) => new Blob([file]));
      return await Promise.all(
        blobFiles.map((file, index) => ({
          url: files[index] as string,
          fileName: 'suggested image',
          fileSize: file.size,
        })),
      );
    }

    const currentFiels = Array.from(files as File[]) as [File];

    blobFiles = Array.from(files as File[]).map(async (file: File) => {
      if (!/heic/.test(file.type)) {
        return URL.createObjectURL(file);
      } else {
        const heic2any = await import('heic2any');
        const blob = (await heic2any.default({
          blob: file,
          toType: 'image/jpeg',
          quality: 0.94,
        })) as any;

        return URL.createObjectURL(blob);
      }
    });

    const sources = await Promise.all(blobFiles).then((res) => {
      return res.map((url, index) => ({
        url: url,
        fileName: currentFiels[index].name,
        fileSize: currentFiels[index].size,
      }));
    });

    return sources;
  } catch (e) {
    return null;
  }
}

export function createPixelArray(imgData: Uint8ClampedArray): number[][] {
  const pixels = imgData;
  const pixelArray = [];

  for (let i = 0, r, g, b; i < imgData.length; i = i + 4) {
    r = pixels[i];
    g = pixels[i + 1];
    b = pixels[i + 2];

    pixelArray.push([r, g, b]);
  }
  return pixelArray;
}
